import React, { useState } from 'react';
import { PlayIcon, TimerIcon } from 'lucide-react';
import { useTimer } from '../../../contexts/TimerContext';
import type { Case } from '../../../types/admin';
interface StartTimerButtonProps {
  caseItem: Case;
  className?: string;
}

/** "Start timer" — eller "Timer kører" hvis timeren allerede kører på denne sag. */
export function StartTimerButton({
  caseItem,
  className = ''
}: StartTimerButtonProps) {
  const {
    timer,
    startTimer,
    requestStop
  } = useTimer();
  const [busy, setBusy] = useState(false);
  const runningHere = timer?.caseId === caseItem.id;
  return <button type="button" disabled={busy} onClick={async () => {
    if (runningHere) {
      requestStop();
      return;
    }
    setBusy(true);
    await startTimer(caseItem);
    setBusy(false);
  }} className={`inline-flex h-11 items-center justify-center gap-2 whitespace-nowrap rounded-full border px-4 text-sm font-medium transition-colors duration-150 disabled:opacity-60 ${runningHere ? 'border-accent/60 bg-accent/15 text-ink' : 'border-line text-ink hover:border-accent/60 hover:text-accent-deep'} ${className}`} data-id="element-628" data-mp="28yezpjxlavxg">
      {runningHere ? <TimerIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-629" data-mp="3d3tnmbo2up6f" /> : <PlayIcon className="h-4 w-4" aria-hidden="true" data-id="element-630" data-mp="382w1xp3uzd06" />}
      {runningHere ? 'Stop timer' : 'Start timer'}
    </button>;
}